import { gsap } from 'gsap';

const DEFAULTS = {
  texts: ['INPYX: E-commerce, Marketing Digital', 'Performance', 'Mídias', 'SEO', 'Conteúdos para seu website', 'Comunicação que VENDE!'],
  typingSpeed: 75,
  deletingSpeed: 30,
  pauseDuration: 1500,
  initialDelay: 0,
  loop: true,
  showCursor: true,
  cursorCharacter: '|',
  hideCursorWhileTyping: false,  
  cursorBlinkDuration: 0.5
};

function clampSpeed(speed) {
  return Math.max(10, Number(speed) || DEFAULTS.typingSpeed);
}

function getDataTexts(section) {
  const raw = section.dataset.texts || '';
  return raw.split('|').map(text => text.trim()).filter(Boolean);
}

export default {
  init() {
    const sections = document.querySelectorAll('[data-text-type-section]');
    if (!sections.length) return;

    sections.forEach((section) => {
      const contentElement = section.querySelector('[data-text-type-content]');
      const cursorElement = section.querySelector('[data-text-type-cursor]');
      if (!contentElement || !cursorElement) return;

      const texts = getDataTexts(section);
      const typingSpeed = clampSpeed(section.dataset.typingSpeed) || DEFAULTS.typingSpeed;
      const deletingSpeed = clampSpeed(section.dataset.deletingSpeed) || DEFAULTS.deletingSpeed;
      const pauseDuration = Number(section.dataset.pauseDuration) || DEFAULTS.pauseDuration;
      const initialDelay = Number(section.dataset.initialDelay) || DEFAULTS.initialDelay;
      const loop = section.dataset.loop !== 'false';
      const showCursor = section.dataset.showCursor !== 'false';
      const cursorCharacter = section.dataset.cursorCharacter || DEFAULTS.cursorCharacter;
      const hideCursorWhileTyping = section.dataset.hideCursorWhileTyping === 'true';
      const cursorBlinkDuration = Number(section.dataset.cursorBlinkDuration) || DEFAULTS.cursorBlinkDuration;

      cursorElement.textContent = cursorCharacter;
      if (showCursor) {
        gsap.set(cursorElement, { opacity: 1 });
        gsap.to(cursorElement, {
          opacity: 0,
          duration: cursorBlinkDuration,
          repeat: -1,
          yoyo: true,
          ease: 'power2.inOut'
        });
      }

      let currentIndex = 0;
      let currentChar = 0;
      let isDeleting = false;
      let timeoutId = null;
      let visible = true;

      const typedTexts = texts.length > 0 ? texts : DEFAULTS.texts;

      const startTyping = () => {
        clearTimeout(timeoutId);

        const currentText = typedTexts[currentIndex];
        if (!currentText) return;

        const fullText = currentText;
        const shouldHideCursor = hideCursorWhileTyping && !showCursor;
        if (shouldHideCursor) {
          cursorElement.classList.add('text-type__cursor--hidden');
        } else {
          cursorElement.classList.remove('text-type__cursor--hidden');
        }

        if (isDeleting) {
          currentChar -= 1;
          contentElement.textContent = fullText.substring(0, currentChar);
          if (currentChar <= 0) {
            isDeleting = false;
            currentIndex += 1;
            if (currentIndex >= typedTexts.length) {
              if (!loop) return;
              currentIndex = 0;
            }
            timeoutId = setTimeout(startTyping, pauseDuration);
            return;
          }
          timeoutId = setTimeout(startTyping, deletingSpeed);
          return;
        }

        currentChar += 1;
        contentElement.textContent = fullText.substring(0, currentChar);

        if (currentChar < fullText.length) {
          timeoutId = setTimeout(startTyping, typingSpeed);
          return;
        }

        timeoutId = setTimeout(() => {
          isDeleting = true;
          timeoutId = setTimeout(startTyping, deletingSpeed);
        }, pauseDuration);
      };

      setTimeout(startTyping, initialDelay);

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!visible) {
                visible = true;
                timeoutId = setTimeout(startTyping, 200);
              }
            } else {
              visible = false;
              clearTimeout(timeoutId);
            }
          });
        },
        { threshold: 0.1 }
      );

      observer.observe(section);
    });
  }
};
